import { WhatsAppEspAccount } from 'modules/graphql';
import { SendingPlatform } from 'modules/sendingPlatforms/constants';
import { useSendingPlatformsQueryContext } from 'modules/sendingPlatforms/contexts';
import { Skeleton } from 'ui/skeleton';
import { WhatsAppAccount } from './WhatsAppAccount';
import { WhatsAppAccountsEmptyState } from './WhatsAppAccountsEmptyState';

type Props = { sendingPlatform: SendingPlatform };

export const WhatsAppAccountsSection = ({ sendingPlatform }: Props) => {
  const { espAccountsBySendingPlatform, isLoadingEssentialData } =
    useSendingPlatformsQueryContext();

  const espAccounts = espAccountsBySendingPlatform[sendingPlatform] || [];

  if (isLoadingEssentialData) return <Skeleton height={265} />;

  if (!espAccounts.length) return <WhatsAppAccountsEmptyState sendingPlatform={sendingPlatform} />;

  return espAccounts.map((espAccount) => (
    <WhatsAppAccount key={espAccount.id} espAccount={espAccount as WhatsAppEspAccount} />
  ));
};
